import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes, { object } from 'prop-types'
import track from 'react-tracking'
import queryString from 'query-string'
import ReactMarkdown from 'markdown-to-jsx'

import { CoremediaRenderer } from '@ycos/coremedia-renderer'
import BEMHelper from '@ynap/bem-helper'
import { Picture } from '@ycos/picture'
import Address from '@ynap/address'
import { Button } from '@ynap/button'

import { trackGuestOrderTrackSuccess } from '../../GuestOrders/analytics'
import { trackReturnConfirmation } from '../analytics'
import ReturnLabelButton from '../OrderDetailsStatus/ReturnLabelButton/ReturnLabelButton'

const bem = new BEMHelper('ReturnConfirmation')
const defaultProps = {
    contentImageBaseUrl: '',
}
@track()
export class ReturnConfirmation extends PureComponent {
    static propTypes = {
        userTitle: PropTypes.string,
        userLastName: PropTypes.string,
        email: PropTypes.string,
        contentImageBaseUrl: PropTypes.string,
        content: PropTypes.string,
        guestUser: PropTypes.bool,
        returnCourier: PropTypes.string,
    }

    componentDidMount() {
        const { externalOrderId, locale, content, fetchContent, guestUser, tracking } = this.props
        const { id } = queryString.parse(window.location.search)
        const contentKey = id
            ? id === 'drop-confirmation'
                ? 'drop-confirmation'
                : 'collection-step'
            : 'return-confirmation'

        if (locale && typeof content === 'undefined') {
            fetchContent(contentKey, locale?.country, { mv: 'gitMarkdown' })
        }
        tracking?.trackEvent(trackReturnConfirmation(externalOrderId, locale))
        if (guestUser) tracking?.trackEvent(trackGuestOrderTrackSuccess('create return'))
    }

    render() {
        const { datePeriod, timePeriod, id, parcels } =
            typeof window !== 'undefined' && queryString.parse(window.location.search)

        //show drop off confirmation content only for drop off confirm page
        let pageData
        if (id === 'drop-confirmation') {
            pageData = this.props.dropOffConfirmation
        } else if (!id) {
            pageData = this.props.returnConfirmation
        } else {
            pageData = this.props.collectionConfirmation
        }
        const components = [ThankYouPage, ThankYouInfo, ThankYouStep]
        const {
            userTitle,
            userLastName,
            email,
            locale,
            contentImageBaseUrl,
            messages,
            shippingAddress,
            shippingMethod,
            returnCourier,
            dropOffLocatorLink,
            returns,
            exchanges,
            newReturnOrExchangeId,
            externalOrderId,
            fetchReturnLabel,
            clearReturnLabelState,
            returnLabelSuccess,
            returnLabelError,
            isFetchingReturnLabel,
            enableReturnLabelBtnCountryList = [],
        } = this.props

        const isPremierOrder = shippingMethod?.some((method) => method?.toLowerCase().includes('premier'))

        const isReturnLabelEnabledinCountry =
            locale?.country?.toUpperCase() === shippingAddress?.country.toUpperCase() &&
            enableReturnLabelBtnCountryList?.includes(shippingAddress?.country.toUpperCase())

        const returnOrExchangeId =
            newReturnOrExchangeId || returns?.[0]?.returnIdentifier || exchanges?.[0]?.exchangeIdentifier

        const ReturnLabelButtonComponent =
            isReturnLabelEnabledinCountry && !isPremierOrder ? (
                <ReturnLabelButton
                    isConfirmationPage={true}
                    className={bem('returnLabelButton')}
                    returnLabelSuccess={returnLabelSuccess}
                    returnLabelError={returnLabelError}
                    isFetchingReturnLabel={isFetchingReturnLabel}
                    fetchReturnLabel={fetchReturnLabel}
                    clearReturnLabelState={clearReturnLabelState}
                    returnOrExchangeId={returnOrExchangeId}
                    externalOrderId={externalOrderId}
                    email={email}
                    locale={locale}
                    messages={messages}
                />
            ) : null

        if (pageData) {
            return CoremediaRenderer(pageData, components, {
                rules: [
                    ({ item, index }) => {
                        if (item.layoutVariant == 'myaccount-return-thank-you-info') {
                            return {
                                item: {
                                    ...item,
                                    teaserTitle: item.teaserTitle.replace(
                                        '{{givenname}}',
                                        `${userTitle} ${userLastName}`
                                    ),
                                    teaserTextPlain: item.teaserTextPlain.replace('{{email}}', email),
                                    index,
                                },
                                messages,
                                collectionTime: `${datePeriod} ${timePeriod} `,
                                parcels,
                                shippingAddress,
                                id,
                                confirmationType: pageData.key,
                                returnCourier,
                                dropOffLocatorLink,
                            }
                        } else if (item.layoutVariant == 'myaccount-return-thank-you-step') {
                            return {
                                item: {
                                    ...item,
                                    teaserText: returnCourier
                                        ? item?.teaserText
                                              ?.replace(/DHL/, returnCourier)
                                              .replace('{{courier}}', returnCourier)
                                        : item?.teaserText,
                                    contentImageBaseUrl,
                                },
                                ReturnLabelButtonComponent,
                            }
                        }
                    },
                ],
            })
        }
        return null
    }
}

class ThankYouPage extends PureComponent {
    static propTypes = {
        children: object,
        item: object,
    }
    static layoutVariant = 'myaccount-return-thank-you'

    render() {
        return <div className={bem('thankYouPage')}>{this.props.children}</div>
    }
}

class ThankYouInfo extends PureComponent {
    static layoutVariant = 'myaccount-return-thank-you-info'
    static propTypes = {
        item: object,
    }

    getConfirmationMessage() {
        const { collectionTime, parcels, shippingAddress, id, confirmationType, returnCourier, dropOffLocatorLink } =
            this.props
        if (confirmationType === 'collection-step') {
            return (
                <div className={bem('collection')}>
                    <p className={bem('confirmationType', 'collectionStep')}>
                        {this.props.messages.createCollection.collectionTime()}
                    </p>
                    <span className={bem('collectionTime')}> {collectionTime}</span>
                    <p
                        className={bem('confirmationNumber')}
                    >{`${this.props.messages.createCollection.returnConfirmationNumber()}${id}`}</p>
                    <Address className={bem('address')} {...shippingAddress} />
                    <p
                        className={bem('parcelQuantity')}
                    >{`${this.props.messages.createCollection.parcelQuantity()}${parcels}`}</p>
                </div>
            )
        } else if (confirmationType === 'drop-confirmation') {
            return (
                <div className={bem('collection')}>
                    <p className={bem('confirmationType')}>{this.props.messages.createCollection.dropOffRequested()}</p>
                    <Button
                        type="link"
                        component="a"
                        href={dropOffLocatorLink}
                        target="_blank"
                        rel="noreferrer noopener"
                        className={bem('courierServicePoint')}
                    >
                        {this.props.messages.createCollection.courierServicePoint({ returnCourier })}
                    </Button>
                </div>
            )
        }
        return
    }

    render() {
        const { teaserTitle, teaserTextPlain } = this.props.item

        // @todo This needs aligning between brands
        const splitText = teaserTextPlain.split('{{customer-service}}')
        const confirmationMessage = this.getConfirmationMessage()

        return (
            <div className={bem('info')}>
                <div className={bem('infoTitle')}>{teaserTitle}</div>
                <p className={bem('infoText')}>
                    {splitText.length > 1 ? (
                        <>
                            {splitText[0]}
                            <a
                                className={bem('link')}
                                onClick={() => {
                                    document.getElementById('CustomerCare')?.scrollIntoView()
                                }}
                            >
                                {this.props.messages.orderHistory.customerCare()}
                            </a>
                            {splitText[1]}
                        </>
                    ) : (
                        teaserTextPlain
                    )}
                </p>
                {confirmationMessage}
            </div>
        )
    }
}

class ThankYouStep extends PureComponent {
    static layoutVariant = 'myaccount-return-thank-you-step'
    static propTypes = {
        index: PropTypes.number,
        item: object,
        contentImageBaseUrl: PropTypes.string,
    }

    render() {
        const {
            index,
            item: { teaserTitle, picturesAndMedia, teaserText },
            ReturnLabelButtonComponent,
        } = this.props

        return (
            <div className={bem('stepContainer', `step-${index}`)}>
                <div className={bem('step')}>{index}</div>
                <div className={bem('tile')}>
                    <p className={bem('tileTitle')} data-idx={index}>
                        {teaserTitle}
                    </p>
                    <div className={bem('tileText')}>
                        <ReactMarkdown>{teaserText}</ReactMarkdown>
                        {index === 1 && ReturnLabelButtonComponent}
                    </div>
                    <div className={bem('image')}>
                        <Picture images={picturesAndMedia} alt={teaserTitle} lazy={false} />
                    </div>
                </div>
            </div>
        )
    }
}

ReturnConfirmation.defaultProps = defaultProps

const ReturnConfirmationContainer = connect((state) => {
    return {
        contentImageBaseUrl: state.config?.head?.contentImageBaseUrl || '',
        enableReturnLabelBtnCountryList: state.config?.head?.flags?.enableReturnLabelBtnCountryList || [],
        newReturnOrExchangeId: state.orderDetails?.newReturnOrExchangeId,
        shippingAddress: state.orderDetails?.shippingAddress,
        collectionConfirmation: state.content?.['collection-step']?.response?.body?.content?.[0],
        returnConfirmation: state.content?.['return-confirmation']?.response?.body?.content?.[0],
        dropOffConfirmation: state.content?.['drop-confirmation']?.response?.body?.content?.[0],
    }
})(ReturnConfirmation)

export default ReturnConfirmationContainer
